/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import GraphQlClient from '../services/graphql/GraphQlClient';
import { gql } from '@apollo/client';


const FeedQuery = gql`
  query {
    glossaries(stage: PUBLISHED) {
      word
      definition {
        html
      }
    }
  }
`;

export interface Glossary {
  word: string,
  definition: { html: string }
}

type GlossaryMap = Record<string, { html: string }>;


interface SliceState {
  data: GlossaryMap;
  errorMessage: string;
  errored: boolean;
  loaded: boolean;
  loading: boolean;
}

const createState = (): SliceState => ({
  data: {},
  errorMessage: '',
  errored: false,
  loaded: false,
  loading: false,
})


const glossarySlice = createSlice({
  name: 'glossary',
  initialState: createState(),
  reducers: {
    load: (state) => ({ ...state, loaded: false, loading: true }),
    loaded(state, action: PayloadAction<GlossaryMap>) {
      return { ...state, data: action.payload, loaded: true, loading: false };
    },
    handleError(state, action: PayloadAction<Error>) {
      return {
        ...state,
        loaded: true,
        loading: false,
        errored: true,
        errorMessage: action.payload.message
      };
    },
  }
})

const { load, loaded, handleError } = glossarySlice.actions

export const loadGlossary = () => (dispatch: any, getState: () => any) => {
  const sliceState: SliceState = getState()[glossarySlice.name];
  if (sliceState.loaded || sliceState.loading) {
    return;
  }

  dispatch(load());

  const getGlossary = async () => {
    const { data } = await GraphQlClient.query({
      query: FeedQuery
    });
    return data;
  }

  getGlossary()
    .then((data) => {
      const glossaryData: GlossaryMap = {};
      data.glossaries.forEach((item: Glossary) => glossaryData[item.word.toLowerCase()] = item.definition)
      dispatch(loaded(glossaryData))
    })
    .catch((e) => {
      dispatch(handleError(e))
    });
}

export default glossarySlice.reducer

